/**
 * Text Truncation Utilities
 *
 * Shared text truncation functions used across the application.
 */

/**
 * Truncate text to approximately 2 lines.
 *
 * @param text - Text to truncate
 * @param maxChars - Maximum characters (default ~100 for ~2 lines)
 * @returns Object with truncated text and whether truncation occurred
 */
export function truncateText(
  text: string,
  maxChars: number = 100
): { truncated: string; isTruncated: boolean } {
  if (!text || text.length <= maxChars) {
    return { truncated: text || '', isTruncated: false };
  }

  // Find the last space before maxChars to avoid cutting mid-word
  const lastSpace = text.lastIndexOf(' ', maxChars);
  const truncateAt = lastSpace >= maxChars * 0.8 ? lastSpace : maxChars;

  return {
    truncated: text.substring(0, truncateAt).trim() + '...',
    isTruncated: true,
  };
}
